module.exports = __webpack_public_path__ + "media/img/apple-icon-180x180-13eb694e1c9eaae6a3f8b6be6e248d22.png";